<template>
  <div>
    <iModal
      :title="modelTitle"
      v-model="showModal"
      class-name="vertical-center-modal"
      width="600px"
      :mask-closable="false"
      @on-cancel="cancel"
    >
      <div class="admin-add">
        <div class="admin-add-content">
          <Form
            ref="formInline"
            :model="formInline"
            :rules="ruleInline"
            label-position="right"
            :label-width="180"
            @submit.native.prevent
          >
            <FormItem label="中文名称：" prop="name"> 
              <Input v-model="formInline.name" />
            </FormItem>
            <FormItem label="简称："> 
              <Input v-model="formInline.shortname" />
            </FormItem>
            <FormItem label="排序：" prop="showIndex">
              <InputNumber :max="99999999" :min="-10" v-model="formInline.showIndex"></InputNumber>
            </FormItem>
          </Form>
        </div>
      </div>
      <div slot="footer">
        <Button type="primary" :loading="loading" @click="handleSubmit('formInline')">确定</Button>
        <Button @click="cancel">取消</Button>
      </div>
    </iModal>
  </div>
</template>

<script>
import { mapActions } from "vuex";

export default {
  // 新增展馆modal
  name: "pavilion-add",
  props: {
    show: {
      type: Boolean,
      default: false
    }, 
    options:{
      type:Object,
    },
    modelTitle:{
      type:String,
    }
  },
  data() {
    return {
      loading: false,
      showModal: false,
      time: [],
      editId:'',
      formInline: {
        // form双向绑定
        name: "",
        shortname:'',
        showIndex: 0,
      },
      ruleInline: {
        name: [{ required: true, message: "中文名称不能为空", trigger: "blur" }]
      }
    };
  },
  computed: {
    exhibitionInfo() {
      if (JSON.parse(localStorage.vuex)) {
        return JSON.parse(localStorage.vuex).hostSetModule.hostExhibition;
      }
    }
  },
  watch: {
    show(val, oldVal) {
      this.showModal = val;
      if (!val) this.$emit("close");
    },
    options(val){
      if(val.msg){ // 编辑
        this.editId = val.msg.id
      }
    }
  },
  created() {},
  methods: {
    ...mapActions({
      addCity:'hostSetModule/addCity',
    }),
    async handleSubmit(name) {
      let form = this.formInline;
      let valid = await this.validForm(name);
      if (!valid) return;
      this.loading = true;

      let req = {
        ParentId:this.editId,
        Name: form.name,
        Shortname:form.shortname,
        ShowIndex: form.showIndex,
        Leveltype: 3,
        Lng:"",
        Lat: "",
      };
      let bool = await this.addCity(req).catch(err => {
          this.loading = false;
      });
      if (!bool) {
        this.loading = false;
        this.$Message.error("操作失败，请重新尝试");
      } else {
        this.$emit("finish");
        this.$Message.success("操作成功！");
        this.cancel();
        this.loading = false;
      }
    },
    validForm(name) {
      // 验证表单
      return new Promise((resolve, reject) => {
        this.$refs[name].validate(valid => {
          resolve(valid);
        });
      });
    },
    cancel() {
      this.$refs["formInline"].resetFields();
      this.formInline = {
        name: "",
        shortname:'',
        showIndex: 0,
      }
      this.$emit("close");
      this.editId = '';
    }
  }
};
</script>

<style scoped lang="scss">
.admin-add {
  &-content {
    padding: 20px 40px 20px 20px;
  }
}
.admin-add {
  &-title {
    width: 100%;
    text-align: center;
    margin-bottom: 20px;
    font-size: 16px;
  }
  &-content {
    .submit {
      display: flex;
      justify-content: center;
      button {
        margin-left: -75px;
      }
    }
    img {
      width: 150px;
      height: 150px;
    }
  }
  .form-code-item {
    position: relative;
    .form-code-btn {
      position: absolute;
      right: 1px;
      width: 96px;
      top: 2px;
      border: none;
      outline: none;
      &:focus {
        box-shadow: none;
        border: none;
        outline: none;
      }
    }
  }
}
</style>

